import * as types from './types'


export const initialState = {
  ad: [],
}

const notices = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.GET_NOTICES: {
      return {
        ...state,
        ad: payload,
      }
    }
    default:
      return state
  }
}

export default notices
